export enum TrendTypes {
  engagementRate = "engagementRate",
  savings = "savings",
  savingsPercentage = "savingsPercentage",
  usersLoggedIn = "usersLoggedIn",
  engagements = "engagements",
  usersRedeemed = "usersRedeemed",
  redemptions = "redemptions",
  earned = "earned",
  burned = "burned",
  usersEngaged = "usersEngaged",
  recognitions = "recognitions",
  polls = "polls",
  rewardPointsGiven = "rewardPointsGiven",
  rewardPointsPurchased = "rewardPointsPurchased",
  rewardPoints = "rewardPoints",
  usersGivenRecognition = "usersGivenRecognition",
  usersReceivedRecognition = "usersReceivedRecognition",
  views = "views",
  webinarRegistrations = "webinarRegistrations",
  interactions = "interactions"
}
